var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#fff",
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E0F0C",
    d: "M27.256 26.014A5.92 5.92 0 0 0 30 21c0-3.3-2.7-6-6-6s-6 2.7-6 6a5.92 5.92 0 0 0 2.743 5.014c-2.614 1.243-4.457 3.9-4.457 6.986H18c0-3.3 2.7-6 6-6s6 2.7 6 6h1.714c0-3.086-1.842-5.743-4.457-6.986M19.713 21A4.3 4.3 0 0 1 24 16.714 4.3 4.3 0 0 1 28.285 21 4.3 4.3 0 0 1 24 25.286 4.3 4.3 0 0 1 19.713 21"
  })));
};
export default SvgUser;